import React, { createContext, useState, Dispatch, SetStateAction } from 'react';

export const defaultTheme = {
  palette: {
    primary: { main: '#113591', contrastText: '#FFFFFF' },
    secondary: { main: '#003591' },
    success: { main: '#2E7D32' },
    error: { main: '#C62828' },
  },
  typography: {
    fontFamily: "'Gotham', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  components: {
    MuiInputLabel: {
      defaultProps: { shrink: true },
      styleOverrides: {
        root: {
          '&.MuiInputLabel-shrink': {
            backgroundColor: 'white',
            transformOrigin: 'top left',
            '&.Mui-required': {
              padding: '0 0.7rem',
            },
            '&:not(.Mui-required)': {
              padding: '0 0.2rem',
            },
          },
        },
        asterisk: {
          position: 'absolute',
          left: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          fontSize: '1rem',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '2rem',
          fontSize: '0.75rem',
          fontWeight: 'bold',
          padding: '0.5rem 1rem',
          height: '2.25rem',
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '&.MuiAccordionSummary-root, .MuiAccordionSummary-root &': {
            outline: 'none',
            boxShadow: 'none',
            '&:focus': {
              outline: 'none',
              boxShadow: 'none',
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          height: '1.4rem !important',
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          outline: 'none',
          '&.Mui-selected': {
            outline: 'none',
          },
          '&:focus': {
            outline: 'none',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.search-input': {
            borderRadius: '6.25rem',
            backgroundColor: 'var(--color-placeholder)',
            '& fieldset': {
              border: 'none',
            },
            '&:hover fieldset': {
              border: 'none',
            },
            '&.Mui-focused fieldset': {
              border: 'none',
            },
          },
        },
      },
    },
  },
} as const;

type AppTheme = typeof defaultTheme;

interface ThemeContextType {
  theme: AppTheme;
  setTheme: Dispatch<SetStateAction<AppTheme>>;
}

const ThemeContext = createContext<ThemeContextType>({
  theme: defaultTheme,
  setTheme: () => {},
});

export const ThemeProviderCustom: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<AppTheme>(defaultTheme);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
};
